import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import Tab from '../tab';
import Table from '../../../../components/table';
import Pagination from '../../../../components/pagination';

import { getShanghuiTableData } from '../../../../../../../services/api';
import columnsTemp from './columnsTemp';
class DataTable extends React.PureComponent {
    static propTypes = {};

    state = {
        data: null,
        columns: [],
        list: [],
        descItem: 'ExaminationMeetingDate',
        type: 'all',
        total: 0,
        descType: 'desc',
        psize: 20,
        disp: 0,
    };

    // 切换类型
    handleSwitch = index => {
        this.setState(
            {
                type: index ? 'kcb' : 'all',
            },
            () => {
                this.asyncGetTableData(
                    1,
                    this.state.descItem,
                    this.state.psize,
                    'desc',
                    this.state.type,
                    this.state.disp,
                );
                this.resetPagination();
            },
        );
    };

    handleDispChange = disp => {
        if (this.state !== disp) {
            this.setState(
                {
                    disp,
                },
                () => {
                    this.asyncGetTableData(
                        1,
                        this.state.descItem,
                        this.state.psize,
                        'desc',
                        this.state.type,
                        this.state.disp,
                    );
                    this.resetPagination();
                },
            );
        }
    };

    componentDidMount = () => {
        this.asyncGetTableData(1, this.state.descItem, this.state.psize, 'desc', this.state.type, this.state.disp);
        this.formatColumns();
    };

    // 获取数据
    asyncGetTableData = async (pno, sort, psize, order, type, disp) => {
        const data = await getShanghuiTableData(pno, sort, psize, order, type, disp);

        // console.log(data);

        if (data) {
            this.setState(
                {
                    data,
                    total: data.total,
                },
                () => {
                    this.formatList(data.head, data.body);
                },
            );
        }
    };

    renderSortIcon = (name, type) => {
        if (this.state.descItem === name) {
            if (type === 'desc') {
                return styles.icon_desc;
            } else if (type === 'asc') {
                return styles.icon_asc;
            }
        } else {
            return styles.icon_nosort;
        }
    };

    // 可排序标题
    renderSortTitle = item => {
        return (
            <div className={styles.sortTitle} onClick={this.handleSort.bind(this, item.name)}>
                {item.title}
                <span className={this.renderSortIcon(item.name, this.state.descType)} />
            </div>
        );
    };

    // 格式化表头
    formatColumns = () => {
        const res = columnsTemp.map(item => {
            if (item.name === 'No') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 50,
                };
            }

            if (item.name === 'PrecontractedDisclosureD') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 88,
                };
            }

            if (item.name === 'ExaminationMeetingDate' || item.name === 'OnlineStartDate') {
                return {
                    title: item.sortAble ? this.renderSortTitle(item) : item.title,
                    dataIndex: item.name,
                    width: 106,
                    render: (text, record, title, index) => {
                        return (
                            <div
                                style={{
                                    color: '#4a4a4a',
                                    padding: item.name === 'ExaminationMeetingDate' ? '0 10px' : 'none',
                                }}>
                                {text}
                            </div>
                        );
                    },
                };
            }

            if (item.name === 'IssueShares') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 120,
                };
            }

            if (item.name === 'IPOProceeds') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 94,
                };
            }
            if (item.name === 'DeclareState') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 60,
                };
            }

            if (item.name === 'Sponsor') {
                return {
                    title: item.sortAble ? this.renderSortTitle(item) : item.title,
                    dataIndex: item.name,
                    render: (text, record, title, index) => {
                        return (
                            <div
                                style={{
                                    width: 140,
                                    padding: '0 10px',
                                    textAlign: 'left',
                                }}>
                                {text}
                            </div>
                        );
                    },
                };
            }

            if (item.name === 'Plate') {
                return {
                    title: item.sortAble ? this.renderSortTitle(item) : item.title,
                    dataIndex: item.name,
                    width: 90,
                    render: (text, record, title, index) => {
                        return (
                            <div
                                style={{
                                    width: 86,
                                }}>
                                {text}
                            </div>
                        );
                    },
                };
            }

            if (item.name === 'CompanyName') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 140,
                    render: (text, record, title, index) => {
                        if (record.type === 'kcb') {
                            return (
                                <div style={{ padding: '10px 10px', textAlign: 'left' }}>
                                    <span style={{ color: '#e2524b' }}>【科】</span>
                                    {text}
                                </div>
                            );
                        } else {
                            return <div style={{ padding: '10px 10px', textAlign: 'left' }}>{text}</div>;
                        }
                    },
                };
            }
            if (item.name === 'IssueShares') {
                return {
                    title: item.sortAble ? (
                        <div className={styles.sortTitle} onClick={this.handleSort.bind(this, item.name)}>
                            {item.title}
                            <span style={{ fontSize: 12 }}>(万股)</span>
                            <span className={this.renderSortIcon(item.name, this.state.descType)} />
                        </div>
                    ) : (
                        item.title
                    ),
                    dataIndex: item.name,
                    render: (text, record, title, index) => {
                        return <div>{text}</div>;
                    },
                };
            }
            if (item.name === 'IPOProceeds') {
                return {
                    title: item.sortAble ? (
                        <div className={styles.sortTitle} onClick={this.handleSort.bind(this, item.name)}>
                            {item.title}
                            <span style={{ fontSize: 12 }}>(亿)</span>
                            <span className={this.renderSortIcon(item.name, this.state.descType)} />
                        </div>
                    ) : (
                        item.title
                    ),
                    dataIndex: item.name,
                    render: (text, record, title, index) => {
                        return <div>{text}</div>;
                    },
                };
            }

            return {
                title: item.sortAble ? this.renderSortTitle(item) : item.title,
                dataIndex: item.name,
            };
        });

        this.setState({
            columns: res,
        });
    };

    // 格式化列表数据
    formatList = (head, body) => {
        const res = [];

        if (head && body) {
            body.forEach(item => {
                const obj = {};

                head.forEach((ele, i) => {
                    obj[ele] = item[i];
                });

                res.push(obj);
            });

            this.setState({
                list: res,
            });
        }
    };

    // 点击排序
    handleSort = title => {
        if (title === this.state.descItem && this.state.descType === 'desc') {
            this.setState(
                {
                    descItem: title,
                    descType: 'asc',
                },
                () => {
                    this.formatColumns();
                    this.asyncGetTableData(1, title, this.state.psize, 'asc', this.state.type, this.state.disp);
                },
            );
        } else {
            this.setState(
                {
                    descItem: title,
                    descType: 'desc',
                },
                () => {
                    this.formatColumns();
                    this.asyncGetTableData(1, title, this.state.psize, 'desc', this.state.type, this.state.disp);
                },
            );
        }
        this.resetPagination();
    };

    // 点击翻页
    handleChangePage = pagination => {
        this.asyncGetTableData(
            pagination.pageNumber,
            this.state.descItem,
            this.state.psize,
            this.state.descType,
            this.state.type,
        );
    };

    onRef = child => {
        this.child = child;
    };

    resetPagination = () => {
        this.child.resetCur();
    };

    render() {
        const { columns, list, total } = this.state;

        return (
            <div className={styles.dataTable}>
                <Tab onChange={this.handleSwitch} onDispChange={this.handleDispChange} />
                <div style={{ paddingTop: 14 }}>
                    <Table columns={columns} dataSource={list} />
                </div>
                <div style={{ width: 380, margin: '50px auto 116px' }}>
                    <Pagination
                        current={1}
                        total={Number(total) || 0}
                        type={'simple'}
                        pageSize={this.state.psize}
                        onChange={this.handleChangePage}
                        showQuickJumper
                        onRef={this.onRef}
                    />
                </div>
            </div>
        );
    }
}

export default DataTable;
